var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterInstall1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.77347C0 4.37573 4.37573 0 9.77346 0C15.1712 0 19.5469 4.37573 19.5469 9.77347V10.2265C19.5469 15.6243 15.1712 20 9.77346 20C4.37573 20 0 15.6243 0 10.2265V9.77347Z",
    fill: "#00C950"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4906 8.83321C15.757 10.1406 15.5672 11.4999 14.9527 12.6843C14.3382 13.8686 13.3363 14.8066 12.114 15.3416C10.8917 15.8767 9.52291 15.9766 8.23588 15.6246C6.94886 15.2726 5.8214 14.49 5.04153 13.4074C4.26167 12.3247 3.87653 11.0074 3.95034 9.67518C4.02416 8.34293 4.55247 7.07626 5.44717 6.08639C6.34187 5.09652 7.54888 4.44329 8.86691 4.23564C10.1849 4.02798 11.5343 4.27846 12.69 4.94529",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02344 9.41659L9.77344 11.1666L15.6068 5.33325",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(2.77344 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterInstall1Icon);
export default __webpack_public_path__ + "static/media/after_install_1_icon.6609092351d5f6fdd2ba38ad65d1a508.svg";
export { ForwardRef as ReactComponent };